import * as yup from "yup";
import i18n from "i18next";
import { INPUT_LENGTH } from "@duosoftbg/nacid-components";
import { parseDateString } from "../../../../utils/functions";

export const createEmailNotificationFilterValidationSchema = () => {
  yup.setLocale({
    string: {
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
    },
  });

  return yup.object().shape(
    {
      status: yup.string(),
      recipients: yup.string().max(INPUT_LENGTH.MAX_INPUT_LENGTH_S, i18n.t("validation.name.charCount.invalid")),
      createdDateFrom: yup
        .date()
        .transform((value, originalValue) => {
          return parseDateString(value, originalValue);
        })
        .when("createdDateTo", (dateTo, yup) => dateTo && yup.max(dateTo, "validation.createdDate.invalid")),
      createdDateTo: yup
        .date()
        .transform((value, originalValue) => {
          return parseDateString(value, originalValue);
        })
        .when("createdDateFrom", (dateFrom, yup) => dateFrom && yup.min(dateFrom, "validation.createdDate.invalid")),
      sentDateFrom: yup
        .date()
        .transform((value, originalValue) => {
          return parseDateString(value, originalValue);
        })
        .when("sentDateTo", (dateTo, yup) => dateTo && yup.max(dateTo, "validation.sentDate.invalid")),
      sentDateTo: yup
        .date()
        .transform((value, originalValue) => {
          return parseDateString(value, originalValue);
        })
        .when("sentDateFrom", (dateFrom, yup) => dateFrom && yup.min(dateFrom, "validation.sentDate.invalid")),
    },
    [
      ["createdDateFrom", "createdDateTo"],
      ["sentDateFrom", "sentDateTo"],
    ],
  );
};
